import(/* webpackMode: "eager" */ "D:\\Source\\Personal\\xoso\\xoso-client\\src\\app\\event\\create\\page.tsx");
